var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavAjustesWhite = function SvgNavAjustesWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_ajustes_white_svg__Capa_2",
    viewBox: "0 0 29.9 32.56"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_ajustes_white_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.72 5.81 18.14.85a6.36 6.36 0 0 0-6.37 0L3.18 5.81A6.37 6.37 0 0 0 0 11.32v9.92c0 2.27 1.21 4.38 3.18 5.51l8.59 4.96a6.36 6.36 0 0 0 6.37 0l8.59-4.96a6.37 6.37 0 0 0 3.18-5.51v-9.92c0-2.27-1.21-4.38-3.18-5.51ZM14.95 21.77c-3.09 0-5.6-2.51-5.6-5.6s2.51-5.6 5.6-5.6 5.6 2.51 5.6 5.6-2.51 5.6-5.6 5.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.95,
    cy: 16.17,
    r: 5.6,
    fill: "none",
    stroke: "#19d3c5",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavAjustesWhite;